import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
	selector: 'app-proctoring-enable-config-dialog-box',
	standalone: true,
	imports: [],
	templateUrl: './proctoring-enable-config-dialog-box.component.html',
	styleUrl: '../../globalStyle/limit-dialog-box-common.scss'

})
export class ProctoringEnableConfigDialogBoxComponent {

	action = 'enable'
	rulesetName = 'Organization Default'

	constructor(
		private dialogRef: MatDialogRef<ProctoringEnableConfigDialogBoxComponent>,
		private router: Router
	) { }


	close() {
		this.dialogRef.close();
	}


	goToUpgradePlan() {
		this.close();
	}
}
